export const gitVersion = 'ppwr-1.0.13-499-g49287eda';
